"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dashboard = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const Stats_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/components/Stats");
const ActiveUsers_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/components/ActiveUsers");
const NewUsers_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/components/NewUsers");
const Retention_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/components/Retention");
const Lifecycle_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/components/Lifecycle");
const DashboardHeaderFetchRefreshButton_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/components/DashboardHeaderFetchRefreshButton");
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const ProjectDashboardDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/ProjectDashboardDataProvider");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const Stickiness_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/components/Stickiness");
const Events_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/components/Events");
const Funnels_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/components/Funnels");
const Analytics_1 = require("src/hello_assets/src/util/analytics/Analytics");
const Dashboard = () => {
    const isMounted = (0, isMounted_1.default)();
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const currentProjectDataContext = (0, ProjectDashboardDataProvider_1.useProjectDashboardDataContext)();
    const dashboardAlreadyLoaded = currentProjectDataContext.stateQueryCalls.loaded && currentProjectDataContext.stateUpdateCalls.loaded;
    const inProgress = currentProjectDataContext.stateQueryCalls.inProgress || currentProjectDataContext.stateUpdateCalls.inProgress;
    React.useEffect(() => {
        if (isMounted() && !dashboardAlreadyLoaded) {
            currentProjectDataContext.fetchDashboardQueryCalls(projectApiKey);
            currentProjectDataContext.fetchDashboardUpdateCalls(projectApiKey);
            Analytics_1.Analytics.trackViewDashboard();
        }
    }, [isMounted, projectApiKey, dashboardAlreadyLoaded]);
    if (currentProjectDataContext.stateQueryCalls.isError) {
        return React.createElement(React.Fragment, null,
            React.createElement(antd_1.PageHeader, { title: "Dashboard" }),
            React.createElement(PageContent_1.default, null,
                React.createElement(antd_1.Result, { status: "error", icon: React.createElement(React.Fragment, null), title: "Oops, something went wrong", subTitle: "Dashboard cannot be loaded. Please try again.", extra: React.createElement(antd_1.Button, { onClick: () => {
                            currentProjectDataContext.fetchDashboardQueryCalls(projectApiKey);
                            currentProjectDataContext.fetchDashboardUpdateCalls(projectApiKey);
                        }, disabled: inProgress, loading: inProgress },
                        React.createElement("span", null, "Try Again")) })));
    }
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.PageHeader, { title: "Dashboard", extra: React.createElement(DashboardHeaderFetchRefreshButton_1.DashboardHeaderFetchRefreshButton, null) }),
        React.createElement(PageContent_1.default, null,
            React.createElement(PageContent_1.default.Card, null,
                React.createElement(Stats_1.Stats, null)),
            React.createElement(PageContent_1.default.CardSpacer, null),
            React.createElement(PageContent_1.default.Card, null,
                React.createElement(ActiveUsers_1.ActiveUsers, null)),
            React.createElement(PageContent_1.default.CardSpacer, null),
            React.createElement(PageContent_1.default.Card, null,
                React.createElement(NewUsers_1.NewUsers, null)),
            React.createElement(PageContent_1.default.CardSpacer, null),
            React.createElement(PageContent_1.default.Card, null,
                React.createElement(Events_1.Events, null)),
            React.createElement(PageContent_1.default.CardSpacer, null),
            React.createElement(PageContent_1.default.Card, null,
                React.createElement(Retention_1.Retention, null)),
            React.createElement(Funnels_1.Funnels, null),
            React.createElement(PageContent_1.default.CardSpacer, null),
            React.createElement(PageContent_1.default.Card, null,
                React.createElement(Stickiness_1.Stickiness, null)),
            React.createElement(PageContent_1.default.CardSpacer, null),
            React.createElement(PageContent_1.default.Card, null,
                React.createElement(Lifecycle_1.Lifecycle, null))));
};
exports.Dashboard = Dashboard;
